interface CookieOptions {
  expires?: string
  path?: string
  domain?: string
  secure?: boolean
  sameSite?: 'Strict' | 'Lax' | 'None'
}

class CookieService {
  setValue(name: string, value: string, options?: CookieOptions) {
    let cookieString = `${name}=${value}`
    if (options) {
      if (options.expires) {
        cookieString += `; expires=${options.expires}`
      }
      if (options.path) {
        cookieString += `; path=${options.path}`
      }
      if (options.domain) {
        cookieString += `; domain=${options.domain}`
      }
      if (options.secure) {
        cookieString += `; secure`
      }
      if (options.sameSite) {
        cookieString += `; sameSite=${options.sameSite}`
      }
    }
    document.cookie = cookieString
  }

  getValue(name: string) {
    const cookieName = `${name}=`
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length)
      }
    }
    return null
  }

  removeValue(name: string) {
    // Remove cookie with all possible attributes to ensure it's properly deleted
    // Try multiple combinations of attributes that might have been set
    const strategies = [
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; sameSite=Strict;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; sameSite=Lax;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; sameSite=None; secure;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}; secure;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}; sameSite=Strict;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}; sameSite=Lax;`,
      `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}; sameSite=None; secure;`,
    ]

    strategies.forEach((strategy) => {
      document.cookie = strategy
    })
  }

  isItemAvailable(name: string) {
    const value = this.getValue(name)
    return Boolean(value)
  }

  checkCookieExists(name: string): boolean {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.indexOf(`${name}=`) === 0) {
        return true
      }
    }
    return false
  }

  clearCookies() {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      const equalsIndex = cookie.indexOf('=')
      const name = cookie.substring(0, equalsIndex)
      this.removeValue(name)
    }
  }
}

const cookieService = new CookieService()

Object.freeze(cookieService)

export default cookieService
